import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import ModuleVersionStateBadge from "components/ModuleVersionStateBadge";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableVersionCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <ModuleVersionStateBadge
        state={sharedModule.current?.state}
        number={sharedModule.current?.number}
        yanked={sharedModule.current?.yanked}
      />
    </TableSimpleCell>
  );
};

export default SharedModulesTableVersionCell;
